import { useQuery } from '@tanstack/react-query';
import { Dayjs } from 'dayjs';
import {
    getLastLocationDeltaUploadDate,
    getLatestLocationDeltas,
    getLatestLocationDeltaUploadDateForAllLocations,
} from '../../services/locationDelta';
import { QueryKey } from '../../enums/QueryKey';
import { formatLastUploadDate } from '../../utils/dateUtils';
import dayjs from '../../utils/dayjs';
import { appTimezone } from '../../config';
import { ifDateLocationAndWorktype } from '../../utils/componentUtils';

export function useLastLocationDeltaUploadDate(location: number) {
    const { data } = useQuery({
        queryKey: [QueryKey.LastUploadDate + '-locationDelta', { location }],
        queryFn: () => getLastLocationDeltaUploadDate(location),
        enabled: !!location,
    });

    return formatLastUploadDate(data);
}

export function useLatestLocationDeltas({
    date,
    location,
    worktype,
    channel,
}: {
    date: Dayjs;
    location: number;
    worktype: number;
    channel: number;
}) {
    const dateFromStr = dayjs(date).tz(appTimezone).startOf('month').toISOString();
    const dateToStr = dayjs(date).tz(appTimezone).endOf('month').toISOString();

    const { data, refetch } = useQuery({
        queryKey: [
            QueryKey.LatestLocationDeltas,
            { dateFrom: dateFromStr, dateTo: dateToStr, location, worktype, channel },
        ],
        queryFn: () =>
            getLatestLocationDeltas({ dateFrom: dateFromStr, dateTo: dateToStr, location, worktype, channel }),
        enabled: ifDateLocationAndWorktype({ date, location, worktype }),
    });

    return { data, refetch };
}

export function useLatestLocationDeltaUploadDateForAllLocations() {
    const { data } = useQuery({
        queryKey: [QueryKey.LastUploadDate + '-locationDelta-all-locations'],
        queryFn: () => getLatestLocationDeltaUploadDateForAllLocations(),
        initialData: [],
    });

    return [data];
}
